import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { resolveMenu, pathToNode, groupSlug } from '../lib/menu';

// Breadcrumb trail derived from the site menu: Home > [Group] > Page.
// Renders only for pages that exist in the menu (nothing on the home page).
export default function Breadcrumbs() {
  const { settings, customPages } = useAuth();
  const { pathname } = useLocation();
  if (pathname === '/') return null;

  const resolved = resolveMenu({
    customPages,
    menuTree: (settings && settings.menuTree) || [],
    customGroups: (settings && settings.customGroups) || [],
  });

  const trail = pathToNode(resolved, (n) => (n.kind === 'page' && n.path === pathname) || (n.kind === 'group' && n.landingPath === pathname));
  if (!trail) return null;
  const page = trail[trail.length - 1];
  const groups = trail.slice(0, -1);

  return (
    <nav
      data-testid="breadcrumbs"
      aria-label="Breadcrumb"
      className="border-b"
      style={{ background: 'var(--cream)', borderColor: 'rgba(0,0,0,0.08)' }}
    >
      <div className="max-w-6xl mx-auto px-4 py-2 flex items-center gap-1.5 text-sm flex-wrap" style={{ color: 'var(--olive)' }}>
        <Link to="/" className="flex items-center gap-1 hover:underline" style={{ color: 'var(--navy)' }} data-testid="breadcrumb-home">
          <Home size={14} /> Home
        </Link>
        {groups.map((g, i) => (
          <React.Fragment key={g.id}>
            <ChevronRight size={13} />
            <Link to={g.landingPath || `/menu/${groupSlug(g.id)}`} className="hover:underline" style={{ color: 'var(--navy)' }} data-testid={i === 0 ? 'breadcrumb-group' : `breadcrumb-group-${i}`}>{g.label}</Link>
          </React.Fragment>
        ))}
        <ChevronRight size={13} />
        <span style={{ color: 'var(--navy)', fontWeight: 600 }} data-testid="breadcrumb-current">{page.label}</span>
      </div>
    </nav>
  );
}
